import styled from 'styled-components'

import DotLoader from '../../../Loader/DotLoader'

export const StyledDotLoader = styled(DotLoader)`
  width: 100%;
  aspect-ratio: 5/3.35;
  display: flex;
  justify-content: center;
  align-items: center;

  & > div {
    height: 0.4rem;
    width: 0.4rem;
    margin-right: 0.4rem;
  }
`
